import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import FavoriteIcon from '@material-ui/icons/Favorite';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';


import swal from 'sweetalert';

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Cate from './Cate';

import Service1 from './Services';
import Tag1 from './Tags';

import slid7 from '../assets/images/Slider (1).png';



// import slider1 from '../assets/images/Green Modern Plant Prototype Desktop.png'
// import slider1 from '../assets/images/slider (1).jpg'
import slider2 from '../assets/images/Slider (1).png'
import slider3 from '../assets/images/Slider (2).png'
import slider4 from '../assets/images/Slider (3).png'
import slider5 from '../assets/images/Slider (4).png'



// import slider1 from '../assets/images/sliders (1).png'
// import slider2 from '../assets/images/sliders (2).png'
// import slider3 from '../assets/images/sliders (3).png'
// import slider4 from '../assets/images/sliders (4).JPG'

// import sl3 from '../assets/images/slide (1).png'
// import sl2 from '../assets/images/slide (2).png'
// import sl1 from '../assets/images/slide (3).png'

import Reviews from './review';

import Carousel1 from './Carosel';
import Carousel2 from './Carosel6';
import Carousel3 from './Carosel7';

import Carousel4 from './Carosel3';
import Carousel5 from './Carosel4';
import Carousel6 from './Carosel5';

import Ico from './iconBox';

// import "react-multi-carousel/lib/styles.css";





const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};






const Home = ( props ) => {
    const  responsive= {
      0: {
          items: 1,
      },
      450: {
          items: 2,
      },
      600: {
          items: 3,
      },
      1000: {
          items: 4,
      },
  }
    const  responsive1= {
      0: {
          items: 2,
      },
      450: {
          items: 2,
      },
      600: {
          items: 3,
      },
      750: {
          items: 4,
      },
      1000: {
          items: 7,
      },
  }
    const  responsive2= {
      0: {
          items: 2,
      },
     
      450: {
          items: 3,
      },
      600: {
          items: 4,
      },
      1000: {
          items: 6,
      },
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const options = {
    // margin: 30,
    // responsiveClass: true,
    // nav: true,
    // dots: false,
    // autoplay: false,
    // navText: ["Prev", "Next"],
    // smartSpeed: 1000,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 4,
        },
        1600: {
            items: 4,

        }
    },
};
    const [Categories , setCategories] = useState([])
    const [Categories1 , setCategories1] = useState([])
    const [Homo , setHomo] = useState([])
    const [product , setproduct] = useState([])
    const [dis , setdis] = useState(false)

    const [product1 , setproduct1] = useState([])
    const [product8 , setproduct8] = useState([])
    const [product9 , setproduct9] = useState([])
    const [product10 , setproduct10] = useState([])
    const [product11 , setproduct11] = useState([])
    const [UserDatat , setUserDatat] = useState({})
    const [userHeader , setuserHeader] = useState(false)
    const [SliderPhoto , setSliderPhoto] = useState([])
    const [ArrivalPhoto , setArrivalPhoto] = useState([])
    const [BannerPhoto , setBannerPhoto] = useState([])
    const [MainCatogories , setMainCatogories] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    const [SubClassCategories , setSubClassCategories] = useState([])
    const [SubClassCategories1 , setSubClassCategories1] = useState([])
    const [SubClassCategories2 , setSubClassCategories2] = useState([])
    const [DataPart2 , setDataPart2] = useState([])
    const [fvalue , setfvalue] = useState([])
    const [data, setdata] = useState([]) 
    const [companieswith , setcompanieswith] = useState([])
    const [couponShow , setcouponShow] = useState(true)
    const [chk1 , setchk1] = useState(true)
    const [chk2 , setchk2] = useState(true)
    const [Cate1 , setCate1] = useState([])
    const [Cate2 , setCate2] = useState([])

    const [Ite1 , setIte1] = useState(1)
    const [Ite2 , setIte2] = useState(1)

    const [fg , setfg] = useState(true)
    // var settings = {
    //   infinite: true,
    //   dots: true,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   lazyLoad: true,
    //   autoplay: true,
    // autoplaySpeed: 2000,
    // };
    useEffect(() =>{

        window.scrollTo(0, 0)
        setInterval(() => {
          if( document.getElementsByClassName("carousel-indicators")[0])
          document.getElementsByClassName("carousel-indicators")[0].remove()
        }, 1000);
        
      // document.getElementsByClassName("carousel-indicators")
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[1].remove()
      console.log(    document.getElementsByClassName("carousel-indicators")[0]
      )
        fetch("https://paint-saudi-rayidh-main-back.vercel.app/slider-photo",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res=>res.json())
        .then(res1=>{
            console.log(res1[0]);
            setSliderPhoto(res1)
          })
     
        fetch("https://paint-saudi-rayidh-main-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res2=>res2.json())
        .then(res3=>{
            console.log(res3);
            // setMainCatogories(res3)
            

            let dat = []
            res3.map((res55,c)=>{
                dat.push(res55)
            })
            // console.log(SubClassCategories,asse)
            console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCatogories(data)
            
        })





        localStorage.removeItem("SearchData")
        localStorage.removeItem("Data")
        localStorage.removeItem("CartPrice")
        localStorage.removeItem("CateProduct")

    
        var data1 =  JSON.parse(localStorage.getItem("Cart")) 
  
        fetch("https://paint-saudi-rayidh-main-back.vercel.app/AllProduct",{
       method: "GET",
        headers :  {
        "Content-Type" : "application/json" , 
    }
   })
   .then(res5=>res5.json())
   .then(res6=>{
    localStorage.setItem("Prod",JSON.stringify(res6))
    //    console.log(res6);
    const pro = []
    const pro1 = []
    const pro2 = []
    const pro3 = []
    res6.map((res7,i)=>{
        //    console.log(res7.Product_Popular );
        if ( res7.Arrival){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro.push(res7)
        }
        if ( res7.Arrival1){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro1.push(res7)
        }
        if ( res7.Arrival2){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro2.push(res7)
        }
        if ( res7.Arrival3){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro3.push(res7)
        }
    })
    // setproduct(pro.reverse())
    setproduct8(pro)
    setproduct9(pro1)
    setproduct10(pro2)
    setproduct11(pro3)
    setproduct(pro.slice(0,8))
    setproduct1(pro1.slice(0,8))
    // setproduct1(pro1.slice(0,7))
    // setproduct1(pro1)
    setdis(true)
   })
  

 },[])

 const savethedetailproduct = (data) =>{
    localStorage.setItem("Data" , JSON.stringify(data) )
    console.log(data);
 }
 
 
 const cate =(Categories) =>{
     var Cat1 = Categories.split(" ").join("-")
     
     localStorage.setItem("Cate" , JSON.stringify(Categories) )
     
     setTimeout(()=>{
            props.history.push(`/shop/categories/SAR. {Cat1}`)
        },1500)
    }
    
    
    const carrouselInit =() => {

      var carrousel = document.getElementById("carrouselimg1");
      carrousel.style.opacity = "1";
      setInterval(carrouselAutoChange, 3500);
    
    }
    
    const carrouselAutoChange=()  =>{
      carrouselRight();
    }
    
    
    
    const carrouselChange=(i) => {
    
      var carrousel = document.getElementById("carrouselimg" + i);
      carrousel.style.opacity = "1";
    
    }
    
    
    const carrouselLeft=()  =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 0) {
                  return carrouselChange(4);
              }
              return carrouselChange(num - 1);
          }
      }
    }
    
    const carrouselRight=() =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 3) {
                  return carrouselChange(1);
              }
              return carrouselChange(num + 1);
          }
      }
    }
    
    
        return (
            
          <div>
          <div className="page-wrapper">
            
            {/* End .header */}
            <main className="main">
            {/* <main className="main" style={{backgroundColor: '#fafafa'}}> */}
              <div className="intro-section change-height-slider" >
                <div className="container">
                  <div className="row">
                    
                    <div className="col-xl-12 col-md-12 col-12 mb-md-0" style={{padding:"0px"}}>
                      <div className="intro-slider-container">
                        {/* <div className="intro-slider owl-carousel owl-theme owl-nav-inside row cols-1" data-toggle="owl" data-owl-options="{
                                          &quot;nav&quot;: false,
                                          &quot;dots&quot;: true,
                                          &quot;autoplay&quot;: false,
                                          &quot;autoplayTimeout&quot;: 10000,
                                          &quot;animateOut&quot;: &quot;fadeOut&quot;
                                      }"> */}











<Carousel autoPlay={true} interval={4000} showThumbs={false} showArrows={true} showStatus={false} swipeable={true} swipeAble={true} infiniteLoop={true} style={{height: "300px", direction: "ltr"}}>


<div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "790px"}}  onClick={()=>props.history.push("/categories/Bridals/all-products")}>
    <img src={slider5} alt="" className='change-slid' style={{height: "790px"}}/>
  </div>


  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "790px"}} onClick={()=>props.history.push("/categories/Formals/all-products")}   >
    <img src={slider2} alt="" className='change-slid' style={{height: "790px"}}   />
  </div>
  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "790px"}} onClick={()=>props.history.push("/categories/Formals/all-products")}   >
    <img src={slider3} alt="" className='change-slid' style={{height: "790px"}}   />
  </div>
  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "790px"}} onClick={()=>props.history.push("/categories/Formals/all-products")}   >
    <img src={slider4} alt="" className='change-slid' style={{height: "790px"}}   />
  </div>

  </Carousel>


                        </div>
                      
                    </div>
                 
                  </div>
                </div>
              </div>




             












          
























 <marquee behavior="" direction=""  style={{background:"rgb(0, 128, 113)"}}>
                    <center>
<div style={{background:"rgb(0, 128, 113)"}}>

                  {/* <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><FavoriteIcon  style={{color:"white",fontSize:"21px"}}/>  Happiness Guaranteed</span>  
                  <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><LocalMallIcon  style={{color:"white",fontSize:"21px"}}/>  Up to 30% off</span>  
                  <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><CardGiftcardIcon  style={{color:"white",fontSize:"21px"}}/>  Free Gifts with Purchase</span>  
                  <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><FavoriteIcon  style={{color:"white",fontSize:"21px"}}/>  Happiness Guaranteed</span>  
                  <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><LocalMallIcon  style={{color:"white",fontSize:"21px"}}/>  Up to 30% off</span>  
                  <span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}><CardGiftcardIcon  style={{color:"white",fontSize:"21px"}}/>  Free Gifts with Purchase </span> */} 

<span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}>
  <FavoriteIcon style={{color:"white",fontSize:"21px"}}/>
  رضاكم مضمون 100٪
</span>

<span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}>
  <LocalMallIcon style={{color:"white",fontSize:"21px"}}/>
  خصومات حتى 30٪
</span>

<span style={{color:"white",fontSize:"18px",paddingRight:"69px"}}>
  <CardGiftcardIcon style={{color:"white",fontSize:"21px"}}/>
  هدايا مجانية مع الشراء
</span>



</div>
</center>
                    
                    </marquee>







<div className='container' style={{margin: "30px auto",width: "95%"}}>
            <div className='row'  >
            <div className="col-lg-8 col-sm-12 jkjkjk" style={{margin  :"auto",background:"#e7f5ef",padding:"20px 70px"}}>


         <center>
     <h1 className='dgkj' style={{fontSize:"25px",fontWeight:"600",margin:"0px",color:"#008071"}}>
  وجهتك الشاملة للدهانات واللوازم
</h1>

<p style={{ fontFamily: "Quicksand, sans-serif", fontSize:"1.8rem", color: "black"}}>
  <b>شركة ألوان القوس للدهانات</b> هي وجهتك المثالية للتسوق عبر الإنترنت للحصول على دهانات عالية الجودة، والطلاءات، والفرش، والبكرات، وجميع مستلزمات الدهان في الرياض. مع سنوات من الخبرة في صناعة الدهانات، نقدم أفضل المنتجات، أسعار تنافسية، وتوصيل سريع في جميع أنحاء المملكة العربية السعودية.
</p>

<br />


          
         </center>
        
           
          
            </div>
            </div>
            </div>













<Service1 />












             <br />

              <div className="container banner-group-1">
                <div className="categories">
                  {/*

                  <h3 className="title text-center font-weight-bold mt-1" style={{marginBottom : "0px",borderBottom :"3px solid rgb(40, 108, 83)",width: "fit-content",textAlign:"center"}}>Top Categories this Week</h3>
              */}
                   <center>   <h1 className="title text-center" style={{  height: "39px",padding  : "0px",margin : "0px" ,fontWeight:"600",margin:"0px",color:"#008071",fontSize:"32px"}}> تسوق حسب الفئة

  
</h1>
                  </center>
                  <div 
                
                              >
     
                  
                    
                    <div className='row' style={{}}>
                    <Cate />
                
                                               






                                          </div>





                  </div>
                </div>
              
<br />

                <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>

              <h1 className="title font-weight-bold" style={{  height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545",fontWeight:"800",margin:"0px",color:"#008071",}}> بوية بلاستيك
  
</h1>
                      
                </div>
                <div>
             



<Carousel2/><br />          


           <center>
           <Link to={"/categories/بوية بلاستيك/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 18px",fontSize:"16px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>

            </center>  
            <br />          
                </div>  
              </div>
              <br />











           <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>

              <h1 className="title font-weight-bold" style={{  height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545",fontWeight:"800",margin:"0px",color:"#008071",}}> بوية ناري نيشنل


  
</h1>
                        
                </div>
                <div>
             



<Carousel3/><br />          


           <center>
           <Link to={"/categories/بوية ناري نيشنل/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 18px",fontSize:"16px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>

            </center>  
            <br />          
                </div>  
              </div>
              <br />







<Tag1 />





              {/* <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="">
                      <div className="bg-image d-flex justify-content-center kjkjkjkj" style={{backgroundImage: 'url('+slid7+')',backgroundRepeat : "no-repeat" ,height:  "470px",backgroundColor : "transparent"}}>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

            
                <div className="container icon-boxes-section">
    {/*               <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2">

                  <div>
                 
                 < Ico/>
                

                  </div>

                </div> */}



       






           <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>

              <h1 className="title font-weight-bold" style={{  height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545",fontWeight:"800",margin:"0px",color:"#008071",}}> بوية ناري كروز

  
</h1>
                        
                </div>
                <div>
             



<Carousel4/><br />          


           <center>
           <Link to={"/categories/بوية ناري كروز/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 18px",fontSize:"16px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>

            </center>  
            <br />          
                </div>  
              </div>
              <br />
              <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>
                <h1 className="title font-weight-bold" style={{height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545",fontWeight:"800",margin:"0px",color:"#008071",}}> JOTUN PAINTS




</h1>
{/* <Link to={"/categories/Luxury Pret/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 8px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link> */}
                        
                        </div>
                        <div>
                     


<Carousel5/><br />          

<center>
<Link to={"/categories/JOTUN PAINTS/all-products" }><span  className="heading-right" style={{color : "white" ,padding : "7px 18px",fontSize:"16px" , background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>
</center>

<br />          
                
                </div>  
              </div>
              


                <hr className="mt-2 mb-0" />
              </div>

                
              </div>
              <br />
              
              {/* End .container-fluid */}
             
        

<Reviews />


<div className='container' style={{margin: "30px auto",width: "95%"}}>
            <div className='row'  >
            <div className="col-lg-8 col-sm-12" style={{margin  :"auto"}}>


         <center>
       <h1 style={{fontSize:"30px",fontWeight:"800",margin:"0px",color:"#008071"}}>colorpaintksa.com</h1>

<p style={{color: "black"}}>

مرحبًا بكم في <b>colorpaintksa.com</b>، وجهتكم المثالية للحصول على أفضل أنواع الدهانات عالية الجودة في الرياض والمملكة العربية السعودية! 🎨 نحن ملتزمون بتقديم منتجات عالية الجودة تساعدكم على تجميل منازلكم ومكاتبكم بألوان زاهية ومبهجة.

<br /><br />

في <b>colorpaintksa.com</b>، نؤمن أن الدهانات لا تزين الجدران فقط، بل تضيف حياة وحيوية لكل مساحة. سواء كنتم تبحثون عن دهانات داخلية، خارجية، مقاومة للعوامل الجوية، أو دهانات خاصة للتجديد والديكور، لدينا كل ما تحتاجونه.

<br /><br />

<h1 style={{fontSize:"34px",fontWeight:"800",margin:"0px",color:"#008071"}}>💚 لماذا تختارنا؟</h1>
✅ <b>جودة ممتازة:</b> منتجات أصلية ومختارة بعناية من أفضل الموردين  
<br />
✅ <b>تنوع كبير:</b> دهانات داخلية وخارجية، ومقاومة للعوامل الجوية  
<br />
✅ <b>توصيل سريع وآمن:</b> نوصّل الدهانات إلى باب منزلكم في الرياض والمملكة  
<br />
✅ <b>أسعار منافسة:</b> أسعار مناسبة بدون التنازل عن الجودة  
<br />
✅ <b>دعم وإرشادات:</b> نصائح واختيارات تساعدكم على استخدام الدهانات بأفضل شكل  

<br /><br />

🌍 سواء كنتم أصحاب منازل، مكاتب، أو مشاريع تجارية، فريقنا الخبير هنا لمساعدتكم في اختيار أفضل الألوان والدهانات لمساحتكم. اجعلوا مساحاتكم أكثر جمالًا وحيوية مع <b>paintksa.com</b>—تسوقوا الآن وجددوا ألوانكم! 🎨✨

</p>

<br />


          
         </center>
        
           
          
            </div>
            </div>
            </div>











              
              {/* End .blog-posts */}
            </main>
            
            {/* End .footer */}
          </div>
          <button id="scroll-top" title="Back to Top">
            <i className="icon-arrow-up" />
          </button>
          {/* Mobile Menu */}
          
        
        </div>
        )
    
}

export default Home;